// These IDs must match the seeded `subscriptiontier` collection
// (data-seed/stateful/20260202000001-subscriptionTiers.js). A workspace's
// `subscription.tier` references one of these rows, so a mismatch makes the
// admin tier menu write an orphaned id (blank name in the grid, broken filter).
export const FREE_TIER_ID = '00000000-0000-0000-0000-000000000000';
export const STARTER_TIER_ID = 'a3f2c8d1-4b6e-4a9f-8c2d-1e5f7a9b3c4d';
export const TEAM_TIER_ID = 'b7e9d2f4-6a1c-4e8b-9d3f-2c5a8b4e7f1a';
export const INDUSTRIAL_TIER_ID = 'c4a8e3b6-5d2f-4c9a-8e1b-3f7c9d2a5b8e';
export const ENTERPRISE_TIER_ID = 'd9f3b5c8-7e4a-4d2f-9b6c-1a8e5f3c7d2b';

export const SUBSCRIPTION_TIERS = [
  { id: FREE_TIER_ID, name: 'Free' },
  { id: STARTER_TIER_ID, name: 'Starter' },
  { id: TEAM_TIER_ID, name: 'Team' },
  { id: INDUSTRIAL_TIER_ID, name: 'Industrial' },
  { id: ENTERPRISE_TIER_ID, name: 'Enterprise' },
];
